import type { ReactNode } from 'react'

import { CssBaseline } from '@mui/material'
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'
import GlobalStyle from 'commons/styles/GlobalStyle'
import HVNTheme from 'commons/styles/HAVTheme'
import 'fonts.css'
import 'toast.css'

export const MUIThemeProvider = ({ children }: { children: ReactNode }) => {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={HVNTheme}>
        <CssBaseline />
        <GlobalStyle />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  )
}
